import React from 'react';
import Box from '@mui/system/Box';
import { useStacklineTheme } from '@stackline/ui';
import { GenericNavigationTabs } from 'src/components/BeaconV2Components/SubtabNav/SubtabNavigation';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import ContentSettingsInnerPage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/Settings/ContentSettingsInnerPage';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';

export enum ContentTab {
  Profiles = 'profiles',
  Settings = 'settings'
}

export enum ContentTabsDisplayName {
  Profiles = 'Profiles',
  Settings = 'Master Content'
}

export enum ContentTabsPath {
  Settings = '/account/content/settings'
}

export const ContentNavigationTabs = () => {
  const { beaconNavigator } = useBeaconNavigator();
  const tab = ContentTab.Settings;

  return (
    <GenericNavigationTabs
      tab={tab}
      tabs={[
        {
          label: ContentTabsDisplayName.Settings,
          onClick: () => {
            beaconNavigator.setPathname(ContentTabsPath.Settings);
            beaconNavigator.go();
          },
          value: ContentTab.Settings
        }
      ]}
    />
  );
};

const ContentTopNav = () => {
  return (
    <Flex justifyContent="space-between" flexDirection="row" alignItems="center">
      <Text variant="h2">Content</Text>
    </Flex>
  );
};

const SettingsContentPageLayout = () => {
  const theme = useStacklineTheme();

  return (
    <Box>
      <ContentTopNav />
      <Box marginBottom={theme.spacing.lg}>
        <ContentNavigationTabs />
        <BasePageContainer>
          <ContentSettingsInnerPage />
        </BasePageContainer>
      </Box>
    </Box>
  );
};

export default SettingsContentPageLayout;
